export const ProgressChart = ({ values, unit = "", testId }) => {
  if (!values?.length) return <div className="empty">No data yet</div>;
  const min = Math.min(...values), max = Math.max(...values);
  const pts = values.map((v, i) => [8 + i * (280 / Math.max(values.length - 1, 1)), 8 + (1 - (v - min) / Math.max(max - min, 1)) * 54]);
  const path = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  return (
    <svg viewBox="0 0 296 70" style={{ width: "100%", height: 90 }} data-testid={testId || "progress-chart"}>
      <path d={path} fill="none" stroke="var(--ink)" strokeWidth="2" strokeLinecap="round" />
      {pts.map((p, i) => <circle key={i} cx={p[0]} cy={p[1]} r="2.5" fill="var(--ink)" />)}
      <text x="8" y="66" fontSize="9" fill="var(--ink3)">{min}{unit}</text>
      <text x="262" y="66" fontSize="9" fill="var(--ink3)">{max}{unit}</text>
    </svg>
  );
};
